import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Y si estamos fríos?',
  a: 'Empiezan con toque seguro y risa, no con conversaciones pesadas. El protocolo está diseñado para romper el hielo gradualmente.'
}, {
  q: '¿Y si él no es romántico?',
  a: 'No necesitas poesía. Necesitas 12 minutos de presencia con estructura. Las actividades son claras y ejecutables.'
}, {
  q: '¿Y si una noche no se puede?',
  a: 'Retomas al día siguiente. Esto es vida real con niños, no un examen.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 px-4 bg-[#0a0a0f]" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-xl font-serif text-white mb-6 text-center" data-id="element-3">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-2" data-id="element-4">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-xl bg-[#15151e] border border-white/5 overflow-hidden" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-4 flex items-center justify-between text-left" data-id="element-6">
                <span className="text-white font-medium text-sm sm:text-base" data-id="element-7">
                  {faq.q}
                </span>
                <ChevronDown size={18} className={`text-[#ff2d7a] transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>
              <AnimatePresence data-id="element-9">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-10">
                    <p className="px-4 pb-4 text-gray-400 text-sm" data-id="element-11">{faq.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}